// extracted by mini-css-extract-plugin
export var label = "_co-5";
export var slideContainer = "_co-0";
export var slider = "_co-1";
export var sliderLg = "_co-4";
export var sliderMd = "_co-3";
export var sliderSm = "_co-2";